import React from "react";

export default class Modal extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div>
        {/* <h3>Tip</h3> */}
        {/* // eslint-disable-next-line */}
        <div className="modal fade "
          id={this.props.vinculo}
          data-bs-keyboard="false"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content bg-color1 text-white">
              <div className="modal-header border-bottom-0">
                <h1 className="modal-title" id="exampleModalLabel">
                  {this.props.titulo}
                </h1>
                <button
                  type="button"
                  className="btn-close align-self-start p-2 text-white1"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body justify-content-center">
                <div className="p-2 d-flex justify-content-center align-self-center overflow-hidden">
                  {this.props.children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}